import classNames from "classnames";
import { buildWidgetInstanceId } from "features/widgets";
import React, { useMemo } from "react";
import {
  Container,
  Heading3,
  Icon,
  RenderIf,
  SwiperLayout,
} from "shared/components";
import { useCollectedData } from "shared/contexts/PageData";
import { VIEW_MODES } from "shared/contexts/ViewMode";
import { SwiperSlide } from "swiper/react";

import styles from "./Content058.module.scss";
import { Item } from "./Item";

export const Content058 = ({ payload }) => {
  const title = payload?.title ?? "";
  const template = payload?.template ?? "light";

  const prevRef = React.useRef(null);
  const nextRef = React.useRef(null);

  const instanceId = buildWidgetInstanceId("058", payload.id);
  const { projects } = useCollectedData(instanceId, [
    { name: "projects", defaultValue: [] },
  ]);

  if (projects.length === 0) {
    return null;
  }
  return (
    <div className={classNames(styles.wrapper, styles[template])}>
      <Container className={styles.inner}>
        <div className={styles.top}>
          <Heading3 className={styles.title}>{title}</Heading3>
          <RenderIf viewMode={VIEW_MODES.DESKTOP}>
            <div className={styles["slider-navigation"]}>
              <div
                ref={prevRef}
                className={classNames(
                  styles.navigation,
                  styles["navigation-prev"]
                )}
              >
                <Icon className={styles.icon} name="arrow_slider_prev" />
              </div>
              <div
                ref={nextRef}
                className={classNames(
                  styles.navigation,
                  styles["navigation-next"]
                )}
              >
                <Icon className={styles.icon} name="arrow_slider_next" />
              </div>
            </div>
          </RenderIf>
        </div>
      </Container>
      <div className={styles.slider}>
        <SwiperLayout
          prevRef={prevRef}
          nextRef={nextRef}
          watchOverflow={true}
          slidesPerView={"auto"}
          spaceBetween={4}
          slidesPerGroup={1}
          slidesOffsetAfter={30}
        >
          {projects?.map((item) => (
            <SwiperSlide key={item.id} className={styles.slide}>
              <Item className={styles.item} item={item} />
            </SwiperSlide>
          ))}
        </SwiperLayout>
      </div>
    </div>
  );
};

export default Content058;
